import { FC } from "react";
import { useLocation } from "react-router-dom";
import GameLibrary from "@components/Home/Games/GameLibrary";

const Games: FC = () => {
  const location = useLocation();
  const basePath = location.pathname.startsWith("/portal") ? "portal" : "";
  return <GameLibrary basePath={basePath} />;
};

export default Games;
